import { BusinessRule, BusinessRuleViolation } from "src/app/shared/interfaces/business-rule.interface";
import { IPendingTransactionDetails } from "src/app/shared/interfaces/pending-transaction-details.interface";
import { PendingTransactionRule } from "./pending-transaction-rule-violation-enum";
import { PmsIntegrationTypeEnum } from "src/app/shared/interfaces/PmsIntegrationTypeEnum";

export class FutureCycleFillRule implements BusinessRule<IPendingTransactionDetails> {
    constructor(
      private nowProvider: () => Date = () => new Date()
    ) {}
    
    check(tx: IPendingTransactionDetails): BusinessRuleViolation | null {
        if (
            tx.integrationType === PmsIntegrationTypeEnum.FrameworkLTC &&
            new Date(tx.dispenseDate) > this.nowProvider()
            ) {
                return { id: PendingTransactionRule.FutureCycleFill };
            }
        return null;
    }
}